import React from "react";
import { useTranslation } from "react-i18next";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import { MODAL_TYPES } from "../../utils/emitter";
import useModalActions from "../../hooks/useModalActions";
import "./style.scss";

// item 6: игрок уже прошёл свои +57, но партнёр ещё нет. Клик по ярлыку
// «+57 карточек» рядом с «Играть» показывает статус ожидания — «ждём партнёра».
export default function Extended57WaitPartnerModal() {
  const { t } = useTranslation();
  const { closeModal } = useModalActions();
  return (
    <BaseModal
      className="ext57-wait-partner-modal"
      eventTypeModal={MODAL_TYPES.EXT57_WAIT_PARTNER}
      title={t("extended57.wait_partner.title")}
      description={t("extended57.wait_partner.text")}
    >
      <BaseButton onClick={() => closeModal(MODAL_TYPES.EXT57_WAIT_PARTNER)}>
        {t("extended57.wait_partner.ok")}
      </BaseButton>
    </BaseModal>
  );
}
